import { Fragment } from 'react';
import { IconButton, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionProps } from 'shell/view-models/actions-props';
import { Edit } from '@mui/icons-material';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { PersonSearchStorageVM } from 'shell/view-models/search-anpr';

const ActionsList = ({ cell, filterPersonForm }: ActionProps): React.ReactElement => {
  const navigate = useNavigate();

  const personFilterTable = useFilterTable<PersonSearchStorageVM>();

  const onEditPress = useEventCallback(() => {
    personFilterTable.setValues({ subject: cell, filters: filterPersonForm });

    return new Promise((resolve) => {
      navigate({
        pathname: '/mutazioni/persona/unione-civile/residenti/registrazione',
        search: `?${createSearchParams({
          ricercaNazionale:
            filterPersonForm?.commonSearch?.isNationalResearch?.toString() ||
            filterPersonForm?.subjectData?.isNationalResearch?.toString() ||
            'false',
          codiceFiscale: cell?.fiscalCode || '',
          idSchedaSoggettoANPR: cell?.anpr || '',
          idFamigliaANPR: cell?.idFamilyAnpr || '',
          idSchedaSoggettoComune: cell?.idSchedaSoggettoComune?.idSchedaSoggetto || '',
          codicePersonaSipo: cell?.codicePersonaSipo || '',
        })}`,
      });
      resolve(cell);
    });
  });

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onEditPress();
        }}
        aria-label="Visualizza elemento"
        aria-haspopup="true"
        style={{
          padding: '4px',
        }}
      >
        <Edit />
      </IconButton>
    </Fragment>
  );
};

ActionsList.displayName = 'Action list Union civil page component';

export default ActionsList;
